// React Thirty Party Library
import { Layout as LayoutAntd, Button } from "antd";
import { useLocation } from "react-router";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";

// Constants Library
import { ROUTES } from "../../../constants";

// Components Library
import PageHeaderBar from "./PageHeaderBar";

// Handler Library

// Styles Library
import "../../index.css";

const { Header } = LayoutAntd;

const { MODULE_ROUTE_TITLE } = ROUTES;

const LayoutHeader = (props) => {
  const { collapsed, setCollapsed } = props;

  const path = useLocation();
  const title = MODULE_ROUTE_TITLE[path.pathname] || "";

  return (
    <Header
      className="sidebar-header-container"
      style={{
        width: collapsed ? "calc(100% - 50px)" : "calc(100% - 25vh)",
        transition: "width 0.5s",
        backgroundColor: "#fff",
      }}
    >
      <div className="sidebar-header-title">
        <Button
          type="text"
          icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          onClick={() => setCollapsed(!collapsed)}
          style={{
            fontSize: "16px",
            width: 64,
            height: 64,
          }}
        />
        <h3
          style={{
            fontSize: "17px",
            fontWeight: "bold",
            marginBottom: "7px",
          }}
        >
          {title}
        </h3>
      </div>
      <PageHeaderBar />
    </Header>
  );
};

export default LayoutHeader;
